import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Tabela, Tabler, TabelaCabeca, TabelaCorpo, CorpoTable } from "../../../../../components/formulario/tableStyled";
import { Container, SecaoButao } from "../../../../../components/formulario/styled";
import SearchInput from "../../../../../components/inputs/searchInput";
import ModalExportar from "../../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../../components/pdf/DonwloadPdf";
import LisBadge from "../buttons/listBadge";
import { Fields, Headers } from "./keysOfTable";
import { ButtonFiltroPgInfo } from "../buttons/ButtonFiltroPgInfo";
import { UseList } from "../../context/getListaPg";

interface TabelInfoProps {

}

const TabelInfo: FunctionComponent<TabelInfoProps> = () => {

  const [pesquisarPorNomeEmail, setPesquisaPorMinisterio] = useState('');
  const { pgs} = UseList();
  const [filas, setFilas] = useState({ fila: 0, tamanho: 300 });
  const devRef = useRef(null) as any;

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          setFilas({ fila: filas.fila++, tamanho: filas.tamanho + 300 })
        }
      })
    }
  }, [devRef])

  const Td = () => <>
    {
      pgs
        .filter(element =>
          String(
            element?.nomecelula).toLocaleLowerCase().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, "")
            .match(
              pesquisarPorNomeEmail.toLocaleLowerCase().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, "")
            )
        ).splice(0, (filas.fila + 1) * 30).map(el => <tr>
          {
            Fields?.map(
              nome => <td>{el?.[nome]}</td>
            )
          }
          <td>
            <LisBadge element={el}/>
          </td>
        </tr>)
    }
  </>

  return (
    <>
      <div style={{ display: "flex", flex: 1, padding: 5 }}>
        <Container>

          <SecaoButao style={{ marginBottom: 5 }}>

            <section style={{ display: 'flex', gap: 5 }}>
              <ModalExportar
                callDownloadExcel={() => OpenExcelUniversal(pgs, ["nomesede", "nomecelula", "nomeministerio", "bairro", "frequencia", "membros"])}
                callDownloadPdf={() =>
                  DonwloadPdf(pgs,
                    ["Campus", "Nome", "Tipo de PG", "Bairro", "Frequência", "Quantidade Membros"],
                    ["nomesede", "nomecelula", "nomeministerio", "bairro", "frequencia", "membros"],
                    pgs?.length, [], `${pgs?.length}`)
                }
              />
              <ButtonFiltroPgInfo />

            </section>

            <SearchInput
              title='Procure por nome'
              placeholder="Procure por nome"
              onChange={(e) => setPesquisaPorMinisterio(e.target.value.replace(/script/g, ""))}
            />

            <section />

          </SecaoButao>

          <Tabler>
            {/*@ts-ignore*/}
            <CorpoTable ref={devRef}>

              <Tabela>
                <>
                  <TabelaCabeca>
                    <tr>
                      {
                        Headers?.map(el => <th>{el}</th>)
                      }
                      <th>
                      </th>
                    </tr>
                  </TabelaCabeca>
                  <TabelaCorpo >
                    <Td />
                  </TabelaCorpo>
                </>
              </Tabela>

            </CorpoTable>
          </Tabler>
        </Container>
      </div>
    </>
  )
}

export default TabelInfo;
